module.exports = __webpack_public_path__ + "img/algolia.5d558f2b.svg";